<template>
  <b-form class="mb-5" @submit="onSubmit">
    <b-row
      v-for="(row, index) in combinedFormRows"
      :key="index"
      class="ms-0 ms-0"
    >
      <form-element
        v-for="formElement in row"
        :key="formElement.name"
        v-model="form[formElement.name]"
        :form-element="formElement"
      />
    </b-row>
    <b-row class="ms-0 mt-2">
      <b-col cols="12">
        <b-button type="submit" variant="primary" :disabled="disableForm">{{
          $t("submit")
        }}</b-button>
      </b-col>
      <b-col cols="12">
        <b-alert variant="info" class="mt-3" :show="message.length">{{
          message
        }}</b-alert>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import formElement from "../form/FormElement.vue"
import { register } from "@/services/authentication"
import formElements from "./registerFormElements"
import formAddressElements from "./registerFormAddressElements"
import { BForm, BCol, BRow, BButton, BAlert } from "bootstrap-vue"

export default {
  components: {
    "form-element": formElement,
    BForm,
    BCol,
    BRow,
    BButton,
    BAlert,
  },
  data() {
    return {
      form: {},
      disableForm: false,
      message: "",
    }
  },
  computed: {
    combinedFormRows: function () {
      if (this.form.seperateDeliveryAddress) {
        return formElements.concat(formAddressElements)
      }
      return formElements
    },
  },

  methods: {
    async onSubmit(event) {
      event.preventDefault()
      const result = await register({ userObject: this.form })

      if (result.Error || result.ExceptionLevel === "DANGER") {
        this.message = result.Error ?? result.Message
        return
      }
      this.disableForm = true

      this.message = result
    },
  },
}
</script>
